import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const TrlFeedbackStyled = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'success',
})(({ theme, success }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),
  backgroundColor: theme.palette.colors.infoBackground,
  border: `1px solid ${
    success ? theme.palette.colors.mainFocused : theme.palette.colors.down
  }`,
  borderRadius: '4px',
  maxHeight: '116px',
  overflowY: 'auto',
  alignItems: 'center',
  fontSize: 12,
  padding: theme.spacing(1),

  '& #closeFeedbackIcon': {
    alignSelf: 'flex-start',
  },
}));

export const CircleIconStyled = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== 'success',
})(({ theme, success }) => ({
  cursor: 'pointer',
  position: 'relative',
  color: success ? theme.palette.colors.mainFocused : theme.palette.colors.down,
  height: '20px',
  width: '20px',
}));

export const MessageContainer = styled(Box)(({ theme }) => ({
  width: 'fill-available',
  maxHeight: '98px',
  overflowY: 'auto',

  '@-moz-document url-prefix()': {
    scrollbarColor: `${theme.palette.colors.scrollOnPrimaryBackground} transparent`,
    scrollbarWidth: 'thin',
  },
  '&::-webkit-scrollbar': {
    width: '6px',
    height: '6px',
    display: 'block',
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.colors.scrollOnPrimaryBackground,
    borderRadius: '5px',
  },
}));

export const MessageTitleStyled = styled(Typography)(({ theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  fontSize: '14px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));

export const MessageStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  fontSize: '12px',
  margin: 0,
}));

export const ErrorIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  fontSize: '28px',
  fontWeight: 'bold',
  color: theme.palette.colors.down,
}));
